import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dataspace",
  "use": "icon-dataspace-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-dataspace\"><path d=\"M14.5 8.7 13.4 8l1.1-.7c.7-.4.7-1.2 0-1.6L8.7 2.2C8.5 2.1 8.2 2 8 2s-.5.1-.7.2L1.5 5.7c-.7.4-.7 1.2 0 1.6l.2.1 1-.6-.6-.3L7.8 3h.4l5.7 3.5L8.2 10h-.4L4.6 8l3.3-2h.4l2.3 1.4 1-.6-2.9-1.6C8.5 5.1 8.2 5 8 5s-.5.1-.7.2L1.5 8.7c-.7.4-.7 1.2 0 1.6l5.8 3.5c.2.1.5.2.7.2s.5-.1.7-.2l5.8-3.5c.7-.4.7-1.2 0-1.6M8.2 13h-.4L2.1 9.5l1.5-.9 3.7 2.2c.2.1.5.2.7.2s.5-.1.7-.2l3.7-2.2 1.5.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol